import { refreshToken, getUserinfo } from "@/api/login";
// authLogin,login,
// getInfo, getRoles,
// import { getToken, setToken, removeToken } from "@/utils/auth";
import { setToken, removeToken } from "@/utils/auth";
import {
  getRefreshToken,
  // setRefreshToken,
  removeRefreshToken,
} from "@/utils/auth";
// import { getUser, setUser } from "@/utils/user";
import { $rrj } from "@/utils/rrjutils";
import { getModuleList, allModuleList } from "@/api/setting";
import { getSwitch } from "@/api/user";

const user = {
  state: {
    token: $rrj.storage.get("_token"),
    user: $rrj.storage.get("_ukit"),
    name: "",
    avatar:
      ($rrj.storage.get("_ukit") && $rrj.storage.get("_ukit").avatar) || "",
    roles: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
  },

  actions: {
    LoginInfo({ commit }, data) {
      // console.log(data, "--------------------------------");
      return new Promise((resolve) => {
        $rrj.storage.set("_ukit", data.userInfo.user);
        $rrj.storage.set("_token", data.userInfo.token);
        $rrj.storage.set("_refresh_token", data.userInfo.refresh_token);
        commit("SET_TOKEN", data.userInfo.token.id);
        commit("SET_USER", data.userInfo.user);
        commit("SET_NAME", data.userInfo.user.nickname);
        commit("SET_AVATAR", data.userInfo.user.avatar);
        setToken("token");
        // save login info
        $rrj.storage.set("_login_user", data.loginInfo.user);
        $rrj.storage.set("_login_token", data.loginInfo.token);
        resolve();
      });
    },
    // 登录
    // Login({ commit }, userInfo) {
    //   const account = userInfo.account.trim();
    //   return new Promise((resolve, reject) => {
    //     login(account, userInfo.password)
    //       .then((data) => {
    //         setToken(data.token.id);
    //         setRefreshToken(data.refresh_token);
    //         commit("SET_TOKEN", data.token.id);
    //         // setUser(data.user);
    //         commit("SET_USER", data.user);
    //         commit("SET_NAME", data.user.nickname);
    //         commit("SET_AVATAR", data.user.avatar);
    //         resolve();
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },

    // 微信登录
    // AuthLogin({ commit }, d) {
    //   return new Promise((resolve, reject) => {
    //     authLogin(d)
    //       .then((data) => {
    //         if (data.result === "fail") {
    //           reject(data);
    //         } else {
    //           $rrj.storage.set("_ukit", data.user);
    //           $rrj.storage.set("_token", data.token);
    //           $rrj.storage.set("_refresh_token", data.refresh_token);
    //           commit("SET_TOKEN", data.token.id);
    //           commit("SET_USER", data.user);
    //           commit("SET_NAME", data.user.nickname);
    //           commit("SET_AVATAR", data.user.avatar);
    //           setToken(data.token.id);
    //           resolve(data);
    //         }
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },

    // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo(state.user.id)
    //       .then((data) => {
    //         commit("SET_NAME", data.nickname);
    //         commit("SET_AVATAR", data.avatar);
    //         resolve(data);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },

    // 获取用户信息
    // GetRoles({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getRoles(state.user.id)
    //       .then((data) => {
    //         commit("SET_ROLES", data.roles);
    //         const user = getUser();
    //         commit("SET_NAME", user.nickname);
    //         commit("SET_AVATAR", user.avatar);
    //         resolve(data);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },

    // refresh token
    RefreshToken({ commit }) {
      const token = getRefreshToken();
      return new Promise((resolve, reject) => {
        refreshToken(token)
          .then((data) => {
            $rrj.storage.set("_ukit", data.user);
            $rrj.storage.set("_token", data.token);
            $rrj.storage.set("_refresh_token", data.refresh_token);
            setToken("token");
            commit("SET_TOKEN", data.token.id);
            // setUser(data.user);
            commit("SET_USER", data.user);
            commit("SET_NAME", data.user.nickname);
            commit("SET_AVATAR", data.user.avatar);
            resolve(data.user);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    TokenLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log("token login", data);
        getUserinfo(data.accessToken)
          .then(async (data) => {
            $rrj.storage.set("_ukit", data.user);
            $rrj.storage.set("_token", data.token);
            $rrj.storage.set("_refresh_token", data.refresh_token);
            setToken(data.token.id);
            commit("SET_TOKEN", data.token.id);
            // setUser(data.user);
            commit("SET_USER", data.user);
            commit("SET_NAME", data.user.nickname);
            commit("SET_AVATAR", data.user.avatar);

            const hybridChat = await getSwitch({
              user_id: data.user.id,
              include: "hybrid_douyin_chat",
            });

            // 调用 scrmapi 获取用户信息并存入 storage
            try {
              const scrmInfoRes = await fetch(
                `https://scrmapi.renrenjiang.cn/app/user/info?rrjUserId=${data.user.id}`,
                {
                  headers: {
                    Authorization: `Bearer ${data.token.id}`,
                  },
                }
              );
              const scrmInfo = await scrmInfoRes.json();
              if (scrmInfo.code === 200 && scrmInfo.data) {
                $rrj.storage.set("_scrm_user_info", scrmInfo.data);
              }
            } catch (error) {
              console.error("获取 scrmapi 用户信息失败:", error);
            }

            let res = [];
            if (data.user.uuid && data.user.uuid.indexOf("child_") > -1) {
              res = await getModuleList(data.user.uuid.substring(6));
            } else {
              res = await allModuleList();
            }

            if (hybridChat.hybrid_douyin_chat === "1") {
              res.data[3].children.push({
                id: 171,
                pid: 4,
                path: "/user/groups",
                src: "/views/user/groups",
                icon: "user_index",
                name: "userGroups",
                title: "群聊管理",
                created_at: null,
                updated_at: null,
                status: 1,
                sort_num: 2,
                children: null,
              });
              res.data[4].children.push({
                id: 172,
                pid: 4,
                path: "/database/costomer",
                src: "/views/database/costomer",
                icon: "user_index",
                name: "databaseCostomer",
                title: "潜客管理",
                created_at: null,
                updated_at: null,
                status: 1,
                sort_num: 2,
                children: null,
              });
            }
            $rrj.storage.set("_module", res.data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        $rrj.storage.clear();
        removeToken();
        removeRefreshToken();
        resolve();
      });
    },
  },
};

export default user;
